import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _disconnectAccountRequest = {};
var _disconnectAccountResponse = {};
var _getInstagramAccountRequest = {};
var _getInstagramAccountResponse = {};
var _initiateAccountConnectionRequest = {};
var _initiateAccountConnectionResponse = {};
var _listInstagramAccountsRequest = {};
var _listInstagramAccountsResponse = {};
function resolveWixInstagramV1InstagramAccountServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'instagram_integration.wixapps.net': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/instagram-accounts',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/instagram-accounts/v1',
                destPath: '/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/instagram-accounts/v1',
                destPath: '/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Retrieve hash needed for connection of instagram account to a site. */
export function initiateAccountConnection(payload) {
    var _a = serializer(_initiateAccountConnectionRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_initiateAccountConnectionResponse, {}).fromJSON;
    function __initiateAccountConnection(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.instagram_feed.v1.instagram_account',
            method: 'GET',
            methodFqn: 'wix.instagram.v1.InstagramAccountService.InitiateAccountConnection',
            url: resolveWixInstagramV1InstagramAccountServiceUrl({
                protoPath: '/v1/instagram-accounts/initiate-connection',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __initiateAccountConnection.fromReq = fromReq;
    __initiateAccountConnection.__isAmbassador = true;
    return __initiateAccountConnection;
}
/**
 * Disconnect instagram account from a site.
 *
 * Removes stored Long-life token corresponding to the instagram user id.
 */
export function disconnectAccount(payload) {
    var _a = serializer(_disconnectAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_disconnectAccountResponse, {}).fromJSON;
    function __disconnectAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.instagram_feed.v1.instagram_account',
            method: 'DELETE',
            methodFqn: 'wix.instagram.v1.InstagramAccountService.DisconnectAccount',
            url: resolveWixInstagramV1InstagramAccountServiceUrl({
                protoPath: '/v1/instagram-accounts/{connectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __disconnectAccount.fromReq = fromReq;
    __disconnectAccount.__isAmbassador = true;
    return __disconnectAccount;
}
/**
 * Get instagram account profile.
 *
 * Returns instagram account profile corresponding to account id.
 */
export function getInstagramAccount(payload) {
    var _a = serializer(_getInstagramAccountRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getInstagramAccountResponse, {}).fromJSON;
    function __getInstagramAccount(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.instagram_feed.v1.instagram_account',
            method: 'GET',
            methodFqn: 'wix.instagram.v1.InstagramAccountService.GetInstagramAccount',
            url: resolveWixInstagramV1InstagramAccountServiceUrl({
                protoPath: '/v1/instagram-accounts/{connectionId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getInstagramAccount.fromReq = fromReq;
    __getInstagramAccount.__isAmbassador = true;
    return __getInstagramAccount;
}
/**
 * List instagram accounts connected to the site.
 *
 * Returns list of instagram user ids connected to app instance.
 */
export function listInstagramAccounts(payload) {
    var _a = serializer(_listInstagramAccountsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listInstagramAccountsResponse, {}).fromJSON;
    function __listInstagramAccounts(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.instagram_feed.v1.instagram_account',
            method: 'GET',
            methodFqn: 'wix.instagram.v1.InstagramAccountService.ListInstagramAccounts',
            url: resolveWixInstagramV1InstagramAccountServiceUrl({
                protoPath: '/v1/instagram-accounts',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listInstagramAccounts.fromReq = fromReq;
    __listInstagramAccounts.__isAmbassador = true;
    return __listInstagramAccounts;
}
//# sourceMappingURL=http.impl.js.map